import React, { createContext, useContext, useState, useEffect, useRef } from 'react';

const AuthContext = createContext();

// Decodifica el payload del JWT sin librerías externas
const getTokenExpiration = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000; // convertir a milisegundos
  } catch {
    return null;
  }
};

export const AuthProvider = ({ children }) => {
  const [cliente, setCliente] = useState(() => {
    try {
      const data = localStorage.getItem('cliente');
      return data ? JSON.parse(data) : null;
    } catch { return null; }
  });

  const timerRef = useRef(null);

  const logout = () => {
    setCliente(null);
    localStorage.removeItem('cliente');
    localStorage.removeItem('clienteToken');
    if (timerRef.current) clearTimeout(timerRef.current);
  };

  // Al montar, verificar si el token ya expiró o programar su expiración
  useEffect(() => {
  const programarExpiracion = (token) => {
    const expiracion = getTokenExpiration(token);
    if (!expiracion) return;
    const tiempoRestante = expiracion - Date.now();
    if (tiempoRestante <= 0) { logout(); return; }
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      logout();
      window.location.href = '/login';
    }, tiempoRestante);
  };

  const token = localStorage.getItem('clienteToken');
  if (token) programarExpiracion(token);

  return () => {
    if (timerRef.current) clearTimeout(timerRef.current);
  };
}, []); // eslint-disable-line react-hooks/exhaustive-deps

 const login = (data) => {
  setCliente(data);
  localStorage.setItem('cliente', JSON.stringify(data));
  localStorage.setItem('clienteToken', data.token);

  const expiracion = getTokenExpiration(data.token);
  if (expiracion) {
    const tiempoRestante = expiracion - Date.now();
    if (tiempoRestante > 0) {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        logout();
        window.location.href = '/login';
      }, tiempoRestante);
    }
  }
};

  return (
    <AuthContext.Provider value={{ cliente, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);